import React from 'react'
import './about.css'
import Header from '../component/Header'
import BottomBar from '../component/BottomBar'
import { FaHeart } from 'react-icons/fa6'
import AboutSub from '../component/AboutSub'
import { Helmet } from 'react-helmet-async'

function About() {

  const donationClick =()=>{
    const menu_dropdown = document.querySelector(".donate_header")
    menu_dropdown.classList.toggle("donate_dropDown");
  }

  const year = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>About | The Lord Nations Foundation</title>
        <meta name="description" content="We envision a world where no one is left behind—a world where compassion, kindness, and generosity create lasting change. Through the support of volunteers, donors, and partners, we are making a difference, one life at a time." />
      </Helmet>
      
      <div className='about_container' >
        <Header/>
        <div className='about_head_spacer'></div>
        <div className='about_banner' >
          <div className='about_banner_overlay'>
            <div className='about_banner_label' >
              <h3>About Us</h3>
            </div>
          </div>
        </div>

        <div className='about_sub' >
            <div className='about_sub_header'>
                <div className='about_sub_header_line'></div>
                <h2>WE CREATE LASTING, POSITIVE CHANGE FOR AND WITH CHILDREN</h2>
            </div>

            <p>
              At The Lord Nations Foundation we believe that everyone deserves a chance to live with dignity, hope, and opportunity. Our mission is to provide essential resources, support, and empowerment to the less privileged, including food, education, healthcare, and job opportunities.
            </p>
        </div>

        <div className='about_sub' >
            <div className='about_sub_header'>
                <div className='about_sub_header_line'></div>
                <h2>Our Vision</h2>
            </div>

            <p>
              We envision a world where no one is left behind—a world where compassion, kindness, and generosity create lasting change. Through the support of volunteers, donors, and partners, we are making a difference, one life at a time.
            </p>
        </div>

        <div className='about_sub' >
            <div className='about_sub_header'>
                <div className='about_sub_header_line'></div>
                <h2>ACCELERATING PROGRESS FOR CHILDREN</h2>
            </div>

            <p>
              Our ambition for {year} and more years to come is to inspire progress and achieve three breakthroughs, creating a world in which all children:
            </p>

            <ul>
              <li><span>Food & Shelter:</span> Providing meals and housing assistance to those in need.</li>
              <li><span>Education & Skills Training:</span> Helping individuals build a brighter future through learning.</li>
              <li><span>Healthcare Support:</span> Ensuring access to medical care and essential supplies.</li>
              <li><span>Community Empowerment:</span> Supporting families and individuals with the tools to become self-sufficient.</li>
            </ul>
        </div>

        <div className='about_sub' >
            <div className='about_sub_header'>
                <div className='about_sub_header_line'></div>
                <h2>We help children stay safe, healthy, and learning, transforming children's futures.</h2>
            </div>

            <p>
              Too many children start life at a disadvantage simply because of where and when they are born.Millions of children are dying from preventable causes, and face poverty, violence, disease, and hunger. They are caught up in war zones and disasters they did nothing to create. And they are denied an education and other basic rights owed to them. All children deserve better. 
            </p>

            <p>
              Together with our many partners and supporters worldwide, we find new solutions for children, grounded in our 100+ years of expertise.With more than 25,000 dedicated staff across more than 110 countries, we respond rapidly to humanitarian emergencies, deliver innovative development programmes, and ensure children's voices are heard through our advocacy and campaigning to build a better future for and with children.
            </p>
        </div>
        
        <AboutSub/>

        <div className='about_sub' >
            <div className='about_sub_header'>
                <div className='about_sub_header_line'></div>
                <h2>Get Involved</h2>
            </div>

            <p>
              Your support can change lives! Whether by donating, volunteering, or spreading awareness, you can be a part of this movement of hope.
            </p>

            <div className='about_donation_link'>
              <h3>Join us today and be the reason someone smiles!</h3>
              <div onClick={()=>donationClick()} className='about_header_donate_btn'>
                  <FaHeart className='desk_header_donate_btn_icon' />
                  <h3>DONATE</h3>
              </div>
            </div>
        </div>

        <BottomBar/>
      </div>
    </>
  )
}

export default About